import * as types from './company-tools-categories.types';
export const companyToolsCategoriesPageSelectors: types.ICompanyToolsCategoriesPageSelectors = {
  selectCompanyToolsCategories: (state) => state.page.companyToolsCategories.companyToolsCategoryIds,
};
